import React from 'react';
import { Link } from 'react-router-dom';
import { logoOptionsV2 } from '../components/ui/LogoOptionsV2';

const LogoShowcase = () => {
  return (
    <div className="min-h-screen bg-stone-100 py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <Link to="/" className="text-amber-700 text-sm mb-8 inline-block hover:underline">
          ← Back to Home
        </Link>
        
        <h1 className="text-4xl font-serif text-stone-900 mb-4">Italy Logo Options - Take 2</h1>
        <p className="text-stone-600 mb-12">Better Italy boot shapes - more recognizable. Each shown on light and dark backgrounds.</p>

        <div className="space-y-12">
          {logoOptionsV2.map((option, index) => {
            const LogoComponent = option.component;
            return (
              <div key={option.id} className="border-b border-stone-200 pb-12">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-medium text-stone-900">{option.name}</h3>
                    <p className="text-stone-500 text-sm">{option.description}</p>
                  </div>
                  <span className="text-sm bg-amber-100 text-amber-800 px-3 py-1 rounded-full font-medium">
                    Option {index + 1}
                  </span>
                </div>
                
                <div className="grid md:grid-cols-2 gap-6">
                  {/* Light background */}
                  <div className="bg-white rounded-2xl p-8 flex items-center justify-center shadow-sm">
                    <LogoComponent className="h-12 w-auto" color="dark" />
                  </div>
                  
                  {/* Dark background */}
                  <div className="bg-stone-900 rounded-2xl p-8 flex items-center justify-center">
                    <LogoComponent className="h-12 w-auto" color="light" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Selection note */}
        <div className="mt-16 bg-amber-50 rounded-2xl p-8 text-center">
          <p className="text-stone-700">
            Let me know which option you prefer (1-5) and I'll update the site!
          </p>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
